import { CommonGroupTag } from '../../constants/services.esm.js';
import { LayoutType } from '../../types/layouts.esm.js';

// +-------------+---------+------------+------------++---------------+----------+
// | subgroupTag | named   | has fields | type       || type          | selected |
// +-------------+---------+------------+------------++---------------+----------+
// | current     | *       | *          | predefined || Predefined    | Yes      |
// +-------------+---------+------------+------------++---------------+----------+
// | current     | named   | *          | *          || Saved layout  | Yes      |
// +-------------+---------+------------+------------++---------------+----------+
// | current     | no name | Yes        | *          || Custom layout | Yes      |
// +-------------+---------+------------+------------++---------------+----------+
// | current     | no name | No         | *          || Invalid       |          |
// +-------------+---------+------------+------------++---------------+----------+
// | variation   | named   | *          | *          || Saved layout  | No       |
// +-------------+---------+------------+------------++---------------+----------+
// | variation   | no name | *          | *          || Invalid       |          |
// +-------------+---------+------------+------------++---------------+----------+
// | *           |         |            |            || Invalid       |          |
// +-------------+---------+------------+------------++---------------+----------+
var displayHtmlAsString = function displayHtmlAsString(name) {
  return name ? name.replace(/&lt;/g, '<').replace(/&gt;/g, '>') : '';
};
var getTypeAndSelected = function getTypeAndSelected(entity) {
  var _entity$value, _entity$value2, _entity$value2$column;
  var label = displayHtmlAsString((_entity$value = entity.value) === null || _entity$value === void 0 ? void 0 : _entity$value.name);
  var named = (label === null || label === void 0 ? void 0 : label.length) > 0;
  var hasFields = entity === null || entity === void 0 ? void 0 : (_entity$value2 = entity.value) === null || _entity$value2 === void 0 ? void 0 : (_entity$value2$column = _entity$value2.columns) === null || _entity$value2$column === void 0 ? void 0 : _entity$value2$column.length;
  if (entity.subgroupTag === CommonGroupTag.current) {
    var _entity$value3;
    var predefined = ((_entity$value3 = entity.value) === null || _entity$value3 === void 0 ? void 0 : _entity$value3.type) === LayoutType.Predefined;
    if (predefined) {
      //Predefined layouts are only stored in the database if they are current/instance
      return {
        type: LayoutType.Predefined,
        selected: true
      };
    } else if (named) {
      return {
        type: LayoutType.Saved,
        selected: true
      };
    } else if (hasFields) {
      //Layouts with no names are custom layouts that are currently selected.
      //Custom layouts are only stored in the database if they are current/instance.
      return {
        type: LayoutType.Custom,
        selected: true
      };
    }
  } else if (entity.subgroupTag === CommonGroupTag.variation) {
    if (named) {
      return {
        type: LayoutType.Saved,
        selected: false
      };
    }
  }
  return undefined;
};

export { getTypeAndSelected };
//# sourceMappingURL=get-type-and-selected.esm.js.map
